import React, { useState, useRef, useEffect } from 'react';

const BulkPaymentStatusMenu = ({ selectedOrders, selectAllMode, totalCount, onUpdateStatus, isLoading }) => {
    const [isOpen, setIsOpen] = useState(false);
    const menuRef = useRef(null);

    // Close menu when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen]);

    const handleOptionClick = (status) => {
        if (onUpdateStatus) {
            onUpdateStatus(status);
        }
        setIsOpen(false);
    };

    const isDisabled = (!selectAllMode && (!selectedOrders || selectedOrders.length === 0)) || isLoading;
    const displayCount = selectAllMode ? totalCount : (selectedOrders?.length || 0);

    return (
        <div className="bulkPaymentMenuWrapper" style={{ position: 'relative', display: 'inline-block' }} ref={menuRef}>
            <button
                className="menuButton"
                onClick={() => setIsOpen(!isOpen)}
                disabled={isDisabled}
                title="Payment Options"
                style={{
                    opacity: isDisabled ? 0.5 : 1,
                    cursor: isDisabled ? 'not-allowed' : 'pointer'
                }}
            >
                {isLoading ? (
                    <span className="spinner-small" style={{
                        width: '16px',
                        height: '16px',
                        border: '2px solid transparent',
                        borderTopColor: 'currentColor',
                        borderRadius: '50%',
                        animation: 'spin 1s linear infinite',
                        display: 'inline-block'
                    }}></span>
                ) : (
                    '⋮'
                )}
            </button>

            {isOpen && (
                <div
                    className="bulkPaymentDropdown"
                    style={{
                        position: 'absolute',
                        top: 'calc(100% + 4px)',
                        right: 0,
                        background: '#fff',
                        border: '1px solid #dee2e6',
                        borderRadius: '8px',
                        boxShadow: '0 4px 16px rgba(0, 0, 0, 0.12)',
                        minWidth: '240px',
                        zIndex: 1000,
                        overflow: 'hidden',
                        padding: '8px 0'
                    }}
                >
                    <div style={{
                        padding: '8px 12px',
                        fontSize: '12px',
                        fontWeight: 600,
                        color: '#6c757d',
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px',
                        borderBottom: '1px solid #f1f3f5',
                        marginBottom: '4px'
                    }}>
                        Update Payment Status ({displayCount})
                    </div>

                    <button
                        onClick={() => handleOptionClick('paid')}
                        style={menuItemStyle}
                        onMouseOver={(e) => e.currentTarget.style.background = '#f8f9fa'}
                        onMouseOut={(e) => e.currentTarget.style.background = '#fff'}
                    >
                        <span style={{ marginRight: '8px', fontSize: '12px', background: 'transparent' }}>🟢</span>
                            Mark as Paid &nbsp;
                            <span style={{ fontSize: '11px', color: '#6c757d', background: 'transparent' }}>(App & Shopify)</span>
                    </button>

                    <button
                        onClick={() => handleOptionClick('cod')}
                        style={menuItemStyle}
                        onMouseOver={(e) => e.currentTarget.style.background = '#f8f9fa'}
                        onMouseOut={(e) => e.currentTarget.style.background = '#fff'}
                    >
                        <span style={{ marginRight: '8px', fontSize: '12px', background: 'transparent' }}>🟠</span>
                            Convert to COD &nbsp;
                            <span style={{ fontSize: '11px', color: '#6c757d', background: 'transparent' }}>(App Only)</span>
                    </button>

                    <button
                        onClick={() => handleOptionClick('prepaid')}
                        style={menuItemStyle}
                        onMouseOver={(e) => e.currentTarget.style.background = '#f8f9fa'}
                        onMouseOut={(e) => e.currentTarget.style.background = '#fff'}
                    >
                        <span style={{ marginRight: '8px', fontSize: '12px', background: 'transparent' }}>🔵</span>
                            Convert to Prepaid &nbsp;
                            <span style={{ fontSize: '11px', color: '#6c757d', background: 'transparent' }}>(App Only)</span>
                    </button>
                </div>
            )}
            <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
        </div>
    );
};

const menuItemStyle = {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    padding: '10px 12px',
    border: 'none',
    background: '#fff',
    textAlign: 'left',
    fontSize: '14px',
    color: '#212529',
    cursor: 'pointer',
    transition: 'background 0.15s ease'
};

export default BulkPaymentStatusMenu;
